export default __webpack_public_path__ + "static/media/Group847.7e7ff4db.svg";